import { Grid, Stack, Typography } from '@mui/material';
import { ClosedPlanCard } from '@/components/partial/idp-status-cards/closed';
import { DraftPlanCard } from '@/components/partial/idp-status-cards/draft';
import { InProgressPlanCard } from '@/components/partial/idp-status-cards/in-progress';
import { usePlanActivitiesIndex } from '@/data/idp/plans/activities';
import {
  PlanStatus,
  type Plan,
  type PlansByStatus,
} from '@/data/idp/plans/interfaces';

export const ListPlans = ({ plans }: { plans: PlansByStatus }) => {
  const { activities, isFetching: fetchingActivities } = usePlanActivitiesIndex(
    plans[PlanStatus.InProgress]?.id
  );

  return (
    <Stack spacing={3} data-testid="listPlans">
      {plans[PlanStatus.InProgress] && (
        <Stack spacing={2}>
          <Typography fontWeight="semibold">Em Andamento</Typography>
          <InProgressPlanCard
            activities={activities}
            loadingActivities={fetchingActivities}
            plan={plans[PlanStatus.InProgress]}
          />
        </Stack>
      )}
      {plans[PlanStatus.Draft].length > 0 && (
        <Stack spacing={2}>
          <Typography fontWeight="semibold">Rascunhos</Typography>
          <Grid container spacing={2}>
            {plans[PlanStatus.Draft].map((plan: Plan) => (
              <Grid size={{ xs: 12, md: 4 }} key={plan.id}>
                <DraftPlanCard data-testid="planItemDraft" plan={plan} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      )}
      {plans[PlanStatus.Closed].length > 0 && (
        <Stack spacing={2}>
          <Typography fontWeight="semibold">Finalizados</Typography>
          <Grid container spacing={2}>
            {plans[PlanStatus.Closed].map((plan: Plan) => (
              <Grid key={plan.id} size={{ xs: 12, md: 4 }}>
                <ClosedPlanCard plan={plan} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      )}
    </Stack>
  );
};
